import { CompanyTeamsSortingOption } from '@vyce/core/src/api/types';

export const DEFAULT_TEAMS_LIST_SORTING = {
  field_name: 'name' as CompanyTeamsSortingOption,
  desc: true,
};
